module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/vi/1-2102bf5191f092321226a58d8b664ac2.jpg";